(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ref-cart"]) return;
  try {
    
(function () {
  var ROOT = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/');

  function money(cents) {
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function init(root) {
    root.querySelectorAll('[data-kc]').forEach(function (kc) {
      if (kc.dataset.kcReady) return;
      kc.dataset.kcReady = '1';
      var mode = kc.dataset.kcMode;

      /* ---------- tiroir : ouverture / fermeture ---------- */
      if (mode === 'drawer') {
        window.refCartOpen = function () {
          kc.hidden = false;
          document.documentElement.style.overflow = 'hidden';
        };
        function close() { kc.hidden = true; document.documentElement.style.overflow = ''; }
        kc.querySelectorAll('[data-kc-close]').forEach(function (b) { b.addEventListener('click', close); });
        document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !kc.hidden) close(); });
        // l'icone panier de l'en-tete ouvre le tiroir plutot que la page
        document.querySelectorAll('.ref-header__cart').forEach(function (a) {
          a.addEventListener('click', function (e) { e.preventDefault(); window.refCartOpen(); });
        });
      }

      /* ---------- compte a rebours ---------- */
      var timer = kc.querySelector('[data-kc-timer]');
      if (timer) {
        var mins = parseInt(timer.dataset.minutes, 10) || 10;
        var key = 'ref-cart-timer';
        var end = parseInt(sessionStorage.getItem(key), 10);
        if (!end || isNaN(end) || end < Date.now()) {
          end = Date.now() + mins * 60000;
          sessionStorage.setItem(key, String(end));
        }
        var out = timer.querySelector('[data-kc-time]');
        function tick() {
          var left = Math.max(0, end - Date.now());
          var m = Math.floor(left / 60000), sec = Math.floor((left % 60000) / 1000);
          if (out) out.textContent = ('0' + m).slice(-2) + ':' + ('0' + sec).slice(-2);
          if (left <= 0) { end = Date.now() + mins * 60000; sessionStorage.setItem(key, String(end)); }
        }
        tick(); setInterval(tick, 1000);
      }

      /* ---------- operations panier ---------- */
      function busy(on) { kc.classList.toggle('is-busy', !!on); }
      function reload() { window.location.reload(); }

      function change(body) {
        busy(true);
        return fetch(ROOT + 'cart/change.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body)
        }).then(function (r) { return r.json(); }).then(reload)
          .catch(function () { busy(false); });
      }

      kc.querySelectorAll('[data-kc-qty]').forEach(function (b) {
        b.addEventListener('click', function () {
          var line = parseInt(b.dataset.line, 10);
          var input = kc.querySelector('[data-kc-qty-input][data-line="' + line + '"]');
          var q = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(b.dataset.kcQty, 10));
          change({ line: line, quantity: q });
        });
      });
      kc.querySelectorAll('[data-kc-qty-input]').forEach(function (i) {
        i.addEventListener('change', function () {
          change({ line: parseInt(i.dataset.line, 10), quantity: Math.max(0, parseInt(i.value, 10) || 0) });
        });
      });
      kc.querySelectorAll('[data-kc-remove]').forEach(function (b) {
        b.addEventListener('click', function () { change({ line: parseInt(b.dataset.line, 10), quantity: 0 }); });
      });

      /* ---------- changement de variante sur une ligne ---------- */
      kc.querySelectorAll('[data-kc-variant-select]').forEach(function (sel) {
        sel.addEventListener('change', function () {
          var line = parseInt(sel.dataset.line, 10);
          var node = kc.querySelector('[data-kc-variants="' + line + '"]');
          if (!node) return;
          var variants = JSON.parse(node.textContent || '[]');
          var chosen = [];
          kc.querySelectorAll('[data-kc-variant-select][data-line="' + line + '"]').forEach(function (x) { chosen.push(x.value); });
          var hit = variants.find(function (v) {
            return v.options.length === chosen.length && v.options.every(function (o, i) { return o === chosen[i]; });
          });
          if (!hit) return;
          var input = kc.querySelector('[data-kc-qty-input][data-line="' + line + '"]');
          var qty = parseInt(input ? input.value : '1', 10) || 1;
          // on retire l'ancienne ligne puis on ajoute la nouvelle variante
          busy(true);
          fetch(ROOT + 'cart/change.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ line: line, quantity: 0 })
          }).then(function () {
            return fetch(ROOT + 'cart/add.js', {
              method: 'POST', headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: [{ id: hit.id, quantity: qty }] })
            });
          }).then(reload).catch(function () { busy(false); });
        });
      });

      /* ---------- upsell ---------- */
      kc.querySelectorAll('[data-kc-up]').forEach(function (card) {
        var btn = card.querySelector('[data-kc-up-add]');
        if (!btn) return;
        btn.addEventListener('click', function () {
          var id = parseInt(btn.dataset.default, 10);
          var node = card.querySelector('[data-kc-up-variants]');
          var sels = card.querySelectorAll('[data-kc-up-select]');
          if (node && sels.length) {
            var variants = JSON.parse(node.textContent || '[]');
            var chosen = [];
            sels.forEach(function (x) { chosen.push(x.value); });
            var hit = variants.find(function (v) {
              return v.options.length === chosen.length && v.options.every(function (o, i) { return o === chosen[i]; });
            });
            if (hit) id = hit.id;
          }
          if (!id) return;
          busy(true);
          fetch(ROOT + 'cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
          }).then(function () {
            // le rabais d'upsell passe par un code de reduction, comme sur la source
            var code = kc.dataset.kcUpsellCode || '';
            if (code) { window.location.href = ROOT + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(location.pathname); }
            else reload();
          }).catch(function () { busy(false); });
        });
      });
    });
  }
  document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  if (document.readyState !== 'loading') init(document);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ref-faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    root.querySelectorAll('[data-reffaq-item]').forEach(function (d) {
      if (d.dataset.fqReady) return;
      d.dataset.fqReady = '1';
      var sum = d.querySelector('summary');
      if (!sum) return;
      sum.addEventListener('click', function (e) {
        e.preventDefault();
        if (!d.open) {
          d.open = true;                       // l'ouverture anime toute seule via grid-template-rows
          return;
        }
        // fermeture : on laisse l'animation se derouler avant de retirer `open`
        d.classList.add('is-closing');
        window.setTimeout(function () {
          d.classList.remove('is-closing');
          d.open = false;
        }, 260);
      });
    });
  }
  document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  if (document.readyState !== 'loading') init(document);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ref-featured-collection"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    root.querySelectorAll('[data-refc]').forEach(function (sec) {
      if (sec.dataset.rcReady) return;
      sec.dataset.rcReady = '1';
      var rail = sec.querySelector('[data-refc-rail]');
      var dots = sec.querySelector('[data-refc-dots]');
      if (!rail) return;
      function step() {
        var a = rail.children[0], b = rail.children[1];
        if (!a) return rail.clientWidth;
        return b ? b.getBoundingClientRect().left - a.getBoundingClientRect().left
                 : a.getBoundingClientRect().width;
      }
      function pages() {
        var a = rail.children[0];
        if (!a) return 1;
        var per = Math.max(1, Math.round(rail.clientWidth / a.getBoundingClientRect().width));
        return Math.max(1, rail.children.length - per + 1);
      }
      function current() { return Math.round(rail.scrollLeft / (step() || 1)); }
      function go(i) { var n = pages(); i = ((i % n) + n) % n; rail.scrollTo({ left: i * step(), behavior: 'smooth' }); }
      function paint() {
        if (!dots) return;
        var n = pages(), cur = Math.min(n - 1, current());
        if (dots.children.length !== n) {
          dots.innerHTML = '';
          for (var i = 0; i < n; i++) {
            var d = document.createElement('button');
            d.type = 'button'; d.className = 'refc__dot'; d.setAttribute('aria-label', String(i + 1));
            (function (k) { d.addEventListener('click', function () { go(k); }); })(i);
            dots.appendChild(d);
          }
        }
        [].forEach.call(dots.children, function (d, i) { d.classList.toggle('is-active', i === cur); });
      }
      var raf;
      rail.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(paint); });
      window.addEventListener('resize', paint);
      var p = sec.querySelector('[data-refc-prev]'); if (p) p.addEventListener('click', function () { go(current() - 1); });
      var n2 = sec.querySelector('[data-refc-next]'); if (n2) n2.addEventListener('click', function () { go(current() + 1); });
      paint();
    });
  }
  document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  if (document.readyState !== 'loading') init(document);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ref-product-main"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    root.querySelectorAll('.refpm').forEach(function (sec) {
      if (sec.dataset.pmReady) return;
      sec.dataset.pmReady = '1';

      /* ---------- galerie ---------- */
      var stage = sec.querySelector('[data-pm-stage]');
      var thumbs = sec.querySelectorAll('[data-pm-thumb]');
      var thumbRail = sec.querySelector('[data-pm-thumbs]');

      function slideCount() { return stage ? stage.children.length : 0; }
      function currentIndex() {
        if (!stage || !stage.children.length) return 0;
        var w = stage.children[0].getBoundingClientRect().width || 1;
        return Math.round(stage.scrollLeft / w);
      }
      function goTo(i) {
        if (!stage) return;
        var n = slideCount();
        if (!n) return;
        i = ((i % n) + n) % n;
        var w = stage.children[0].getBoundingClientRect().width || 0;
        stage.scrollTo({ left: i * w, behavior: 'smooth' });
      }
      function paintThumbs() {
        var cur = currentIndex();
        thumbs.forEach(function (t, i) {
          t.parentElement.classList.toggle('is-active', i === cur);
        });
        // garde la miniature active dans le champ de vision
        var active = thumbs[cur];
        if (active && thumbRail) {
          var a = active.getBoundingClientRect(), r = thumbRail.getBoundingClientRect();
          if (a.left < r.left || a.right > r.right) {
            thumbRail.scrollTo({ left: thumbRail.scrollLeft + (a.left - r.left) - (r.width - a.width) / 2, behavior: 'smooth' });
          }
        }
      }
      if (stage) {
        var raf;
        stage.addEventListener('scroll', function () {
          cancelAnimationFrame(raf);
          raf = requestAnimationFrame(paintThumbs);
        });
      }
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () { goTo(parseInt(t.dataset.pmThumb, 10)); });
      });
      var sn = sec.querySelector('[data-pm-stage-next]');
      if (sn) sn.addEventListener('click', function () { goTo(currentIndex() + 1); });

      function scrollThumbs(dir) {
        if (!thumbRail) return;
        var step = thumbRail.getBoundingClientRect().width * 0.8;
        thumbRail.scrollBy({ left: dir * step, behavior: 'smooth' });
      }
      var tp = sec.querySelector('[data-pm-thumb-prev]');
      var tn = sec.querySelector('[data-pm-thumb-next]');
      if (tp) tp.addEventListener('click', function () { scrollThumbs(-1); });
      if (tn) tn.addEventListener('click', function () { scrollThumbs(1); });

      /* ---------- guide des tailles ---------- */
      var sg = sec.querySelector('[data-pm-sg]');
      if (sg) {
        function openSg() { sg.hidden = false; document.documentElement.style.overflow = 'hidden'; }
        function closeSg() { sg.hidden = true; document.documentElement.style.overflow = ''; }
        sec.querySelectorAll('[data-pm-sg-open]').forEach(function (b) { b.addEventListener('click', openSg); });
        sec.querySelectorAll('[data-pm-sg-close]').forEach(function (b) { b.addEventListener('click', closeSg); });
        sg.addEventListener('click', function (e) { if (e.target === sg) closeSg(); });
        document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !sg.hidden) closeSg(); });
      }

      /* ---------- compte a rebours ---------- */
      var timer = sec.querySelector('[data-pm-timer]');
      if (timer) {
        var mins = parseInt(timer.dataset.minutes, 10) || 10;
        var key = 'refpm-timer-' + (sec.id || 'x');
        var end = parseInt(sessionStorage.getItem(key), 10);
        if (!end || isNaN(end) || end < Date.now()) {
          end = Date.now() + mins * 60000;
          sessionStorage.setItem(key, String(end));
        }
        var mm = timer.querySelector('[data-pm-mm]');
        var ss = timer.querySelector('[data-pm-ss]');
        function tick() {
          var left = Math.max(0, end - Date.now());
          var m = Math.floor(left / 60000);
          var s = Math.floor((left % 60000) / 1000);
          if (mm) mm.textContent = ('0' + m).slice(-2);
          if (ss) ss.textContent = ('0' + s).slice(-2);
          if (left <= 0) {
            end = Date.now() + mins * 60000;
            sessionStorage.setItem(key, String(end));
          }
        }
        tick();
        setInterval(tick, 1000);
      }

      /* ---------- bundle ---------- */
      var deals = sec.querySelectorAll('[data-pm-deal]');
      function selectDeal(deal) {
        deals.forEach(function (d) { d.classList.toggle('is-selected', d === deal); });
        var r = deal.querySelector('input[type=radio]');
        if (r) r.checked = true;
      }
      deals.forEach(function (deal) {
        var head = deal.querySelector('[data-pm-deal-head]');
        if (head) head.addEventListener('click', function () { selectDeal(deal); });
      });
      if (deals.length && !sec.querySelector('[data-pm-deal].is-selected')) selectDeal(deals[0]);

      /* ---------- pastilles de couleur ---------- */
      var swVarNode = sec.querySelector('[data-pm-variants]');
      var swVariants = [];
      try { swVariants = JSON.parse(swVarNode ? swVarNode.textContent : '[]'); } catch (e) { swVariants = []; }
      function paintSwatch(row) {
        var img = row.querySelector('.refpm__swatch');
        if (!img) return;
        var chosen = [];
        row.querySelectorAll('[data-pm-sel]').forEach(function (s) { chosen.push(s.value); });
        // variante exacte d'abord, sinon la premiere qui porte cette valeur d'option
        var idx = parseInt(row.querySelector('.refpm__swatch').closest('.refpm__sel-wrap')
          .querySelector('[data-pm-sel]').dataset.opt, 10);
        var hit = swVariants.find(function (v) {
          return v.image && v.options.every(function (o, i) { return o === chosen[i]; });
        }) || swVariants.find(function (v) { return v.image && v.options[idx] === chosen[idx]; });
        if (hit && hit.image) { img.src = hit.image; img.style.visibility = 'visible'; }
        else { img.removeAttribute('src'); img.style.visibility = 'hidden'; }
      }
      sec.querySelectorAll('[data-pm-row]').forEach(function (row) {
        row.querySelectorAll('[data-pm-sel]').forEach(function (s) {
          s.addEventListener('change', function () { paintSwatch(row); });
        });
        paintSwatch(row);
      });

      /* ---------- ajout au panier ---------- */
      var atc = sec.querySelector('[data-pm-atc]');
      var status = sec.querySelector('[data-pm-atc-status]');
      var varNode = sec.querySelector('[data-pm-variants]');
      if (atc && varNode) {
        atc.addEventListener('click', function () {
          var variants = [];
          try { variants = JSON.parse(varNode.textContent || '[]'); } catch (e) { variants = []; }
          var deal = sec.querySelector('[data-pm-deal].is-selected') || deals[0];
          var items = [];
          if (deal) {
            deal.querySelectorAll('[data-pm-row]').forEach(function (row) {
              var chosen = [];
              row.querySelectorAll('[data-pm-sel]').forEach(function (s) { chosen.push(s.value); });
              var match = variants.find(function (v) {
                return v.options.length === chosen.length && v.options.every(function (o, i) { return o === chosen[i]; });
              });
              if (match) items.push({ id: match.id, quantity: 1 });
            });
          }
          if (!items.length) {
            // pas de formule sur cette fiche : on ajoute la variante par defaut, comme la source
            var fallback = parseInt(atc.dataset.defaultVariant, 10);
            if (fallback) items = [{ id: fallback, quantity: 1 }];
          }
          if (!items.length) {
            if (status) status.textContent = atc.dataset.error || '';
            return;
          }
          atc.setAttribute('disabled', 'disabled');
          if (status) status.textContent = '';
          fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: items })
          })
            .then(function (r) { return r.json(); })
            .then(function () {
              window.location.href = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart';
            })
            .catch(function () {
              atc.removeAttribute('disabled');
              if (status) status.textContent = atc.dataset.error || '';
            });
        });
      }
    });
  }
  document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  if (document.readyState !== 'loading') init(document);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ref-promo-popup"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    root.querySelectorAll('[data-refpop]').forEach(function (pop) {
      if (pop.dataset.ppReady) return;
      pop.dataset.ppReady = '1';
      var key = 'refpop-seen';
      var once = pop.dataset.once === 'true';
      if (once && sessionStorage.getItem(key)) return;
      var pct = parseInt(pop.dataset.delay, 10);
      if (isNaN(pct)) pct = 30;

      function open() {
        pop.hidden = false;
        document.documentElement.style.overflow = 'hidden';
        if (once) sessionStorage.setItem(key, '1');
        window.removeEventListener('scroll', onScroll);
      }
      function close() {
        pop.hidden = true;
        document.documentElement.style.overflow = '';
      }
      function onScroll() {
        var h = document.documentElement.scrollHeight - window.innerHeight;
        if (h <= 0) return;
        if ((window.scrollY / h) * 100 >= pct) open();
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      pop.querySelectorAll('[data-refpop-close]').forEach(function (b) { b.addEventListener('click', close); });
      pop.addEventListener('click', function (e) { if (e.target === pop) close(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !pop.hidden) close(); });
      var cta = pop.querySelector('[data-refpop-cta]');
      if (cta && (cta.getAttribute('href') || '').charAt(0) === '#') {
        cta.addEventListener('click', function (e) {
          e.preventDefault();
          close();
          var t = document.querySelector('[data-pm-deal]') || document.querySelector('.refpm');
          if (t) t.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      }
    });
  }
  document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  if (document.readyState !== 'loading') init(document);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ref-testimonials"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    root.querySelectorAll('[data-refts]').forEach(function (sec) {
      if (sec.dataset.tsReady) return;
      sec.dataset.tsReady = '1';
      var rail = sec.querySelector('[data-refts-rail]');
      var dots = sec.querySelector('[data-refts-dots]');
      if (!rail) return;

      function pages() {
        var first = rail.children[0];
        if (!first) return 1;
        var per = Math.max(1, Math.round(rail.clientWidth / first.getBoundingClientRect().width));
        return Math.max(1, rail.children.length - per + 1);
      }
      function step() {
        var first = rail.children[0];
        if (!first) return rail.clientWidth;
        var second = rail.children[1];
        if (!second) return first.getBoundingClientRect().width;
        return second.getBoundingClientRect().left - first.getBoundingClientRect().left;
      }
      function current() { return Math.round(rail.scrollLeft / (step() || 1)); }
      function go(i) {
        var n = pages();
        i = ((i % n) + n) % n;           // boucle : apres la derniere on revient a la premiere
        rail.scrollTo({ left: i * step(), behavior: 'smooth' });
      }
      function paint() {
        if (!dots) return;
        var n = pages(), cur = Math.min(n - 1, current());
        if (dots.children.length !== n) {
          dots.innerHTML = '';
          for (var i = 0; i < n; i++) {
            var b = document.createElement('button');
            b.type = 'button'; b.className = 'refts__dot'; b.setAttribute('aria-label', String(i + 1));
            (function (k) { b.addEventListener('click', function () { go(k); }); })(i);
            dots.appendChild(b);
          }
        }
        [].forEach.call(dots.children, function (d, i) { d.classList.toggle('is-active', i === cur); });
      }
      var raf;
      rail.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(paint); });
      window.addEventListener('resize', paint);
      var p = sec.querySelector('[data-refts-prev]'); if (p) p.addEventListener('click', function () { go(current() - 1); });
      var n2 = sec.querySelector('[data-refts-next]'); if (n2) n2.addEventListener('click', function () { go(current() + 1); });
      paint();
    });
  }
  document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  if (document.readyState !== 'loading') init(document);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ref-video-slider"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    root.querySelectorAll('[data-refvs]').forEach(function (sec) {
      if (sec.dataset.vsReady) return;
      sec.dataset.vsReady = '1';
      var rail = sec.querySelector('[data-refvs-rail]');
      var dots = sec.querySelector('[data-refvs-dots]');
      if (!rail) return;

      function perView() {
        var item = rail.children[0];
        if (!item) return 1;
        return Math.max(1, Math.round(rail.clientWidth / item.getBoundingClientRect().width));
      }
      function pages() { return Math.max(1, Math.ceil(rail.children.length / perView())); }
      function currentPage() {
        var w = rail.clientWidth || 1;
        return Math.min(pages() - 1, Math.round(rail.scrollLeft / w));
      }
      function paint() {
        if (!dots) return;
        var n = pages(), cur = currentPage();
        if (dots.children.length !== n) {
          dots.innerHTML = '';
          for (var i = 0; i < n; i++) {
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'refvs__dot';
            b.setAttribute('aria-label', String(i + 1));
            (function (k) { b.addEventListener('click', function () { go(k); }); })(i);
            dots.appendChild(b);
          }
        }
        [].forEach.call(dots.children, function (d, i) { d.classList.toggle('is-active', i === cur); });
      }
      function go(p) {
        var n = pages();
        p = ((p % n) + n) % n;
        rail.scrollTo({ left: p * rail.clientWidth, behavior: 'smooth' });
      }
      var raf;
      rail.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(paint);
      });
      window.addEventListener('resize', paint);
      var p = sec.querySelector('[data-refvs-prev]'); if (p) p.addEventListener('click', function () { go(currentPage() - 1); });
      var nx = sec.querySelector('[data-refvs-next]'); if (nx) nx.addEventListener('click', function () { go(currentPage() + 1); });
      paint();

      // lecture quand la video entre dans le champ, pause quand elle en sort.
      // `userPaused` protege une pause volontaire : l'observateur ne la rejoue pas.
      function tryPlay(v) {
        if (v.dataset.userPaused === '1') return;
        var pr = v.play();
        if (pr && pr.catch) pr.catch(function () {});
      }
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) tryPlay(e.target);
            else e.target.pause();
          });
        }, { threshold: 0.25 });
        sec.querySelectorAll('video').forEach(function (v) { io.observe(v); });
      } else {
        sec.querySelectorAll('video').forEach(tryPlay);
      }

      // un appui sur la video met en pause ou relance
      sec.querySelectorAll('.refvs__item').forEach(function (item) {
        var v = item.querySelector('video');
        if (!v) return;
        function paint() { item.classList.toggle('is-paused', v.paused); }
        v.addEventListener('play', paint);
        v.addEventListener('pause', paint);
        item.querySelectorAll('[data-refvs-toggle]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            if (v.paused) { v.dataset.userPaused = '0'; tryPlay(v); }
            else { v.dataset.userPaused = '1'; v.pause(); }
          });
        });
        paint();
      });
    });
  }
  document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  if (document.readyState !== 'loading') init(document);
})();

  } catch(e) { console.error(e); }
})();
})();
